import { Teaser } from "./Teaser.js";

/**
 * Class to implement the teaser manager
 * as a singleton, which can be instantiated by
 * any other extension as a dependency
 */
export class TeaserManager {
    private static manager: TeaserManager;
    private instances: Teaser[] = [];

    /**
     * The private constructor
     * prevents direct instantiation
     */
    private constructor() {
        this.teasers.forEach((teaser) => {
            this.instances.push(new Teaser(teaser));
        });
    }

    /**
     * Method to instantiate all
     * teasers on the current page
     *
     * @param {boolean} [reset=false]
     * @returns {TeaserManager}
     */
    public static use(reset: boolean = false): TeaserManager {
        if (!TeaserManager.manager || reset) {
            TeaserManager.manager = new TeaserManager();
        }
        return TeaserManager.manager;
    }

    /**
     * Selects the teasers
     *
     * @returns {NodeListOf<HTMLElement>}
     */
    protected get teasers(): NodeListOf<HTMLElement> {
        return document.querySelectorAll(
            `[data-layout="1"][data-ctype="iunctim_content_teaser"]`,
        );
    }

    /**
     * Returns the number of instantiated teasers
     *
     * @returns {number}
     */
    public get length(): number {
        return this.instances.length;
    }
}
